(function () {
  'use strict';

  var analytics = function () {
    return window.tcbAnalytics || null;
  };

  function parseTopic(href) {
    try {
      var url = new URL(href, window.location.origin);
      return url.searchParams.get('topic') || '';
    } catch (e) {
      return '';
    }
  }

  function linkSource(href) {
    if (!href) return 'unknown';
    if (href.indexOf('cleaning-equipment-advisor') > -1) return 'ai_advisor';
    if (href.indexOf('equipment-finder-and-ai-advisor') > -1) return 'equipment_finder';
    if (href.indexOf('topic=quote') > -1 || href.indexOf('request-a-quote') > -1 || href.indexOf('-quote') > -1 || href.indexOf('upload-rfq') > -1) return 'quote';
    if (href.indexOf('topic=procurement') > -1) return 'procurement';
    if (href.indexOf('topic=b2b') > -1) return 'b2b';
    if (href.indexOf('topic=expert-help') > -1) return 'expert_help';
    if (href.indexOf('/pages/contact') > -1) return 'contact';
    return 'internal';
  }

  function onDocumentClick(event) {
    var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return;

    var ta = analytics();
    if (!ta) return;

    if (href.indexOf('cleaning-equipment-advisor') > -1) {
      ta.advisorOpened({ source: 'link', placement: a.closest('[data-section-id]') ? 'section' : 'nav' });
      return;
    }

    if (href.indexOf('equipment-finder-and-ai-advisor') > -1) {
      ta.finderOpened({ source: 'link' });
      return;
    }

    if (href.indexOf('/pages/contact') > -1 || href.indexOf('request-a-quote') > -1 || href.indexOf('#tcb-contact-form') > -1 || href.indexOf('upload-rfq') > -1) {
      var topic = parseTopic(href) || a.getAttribute('data-tcb-topic') || '';
      if (typeof ta.requestQuote === 'function') ta.requestQuote(linkSource(href), topic);
      else ta.quoteRequested(linkSource(href), topic);
      return;
    }

    if (href.indexOf('tel:') === 0 && typeof ta.callClick === 'function') {
      ta.callClick({ source: linkSource(href) || 'tel_link' });
      return;
    }

    if (href.indexOf('mailto:') === 0 && typeof ta.emailClick === 'function') {
      ta.emailClick({ source: linkSource(href) || 'mailto_link' });
      return;
    }

    if (
      (href.indexOf('financ') > -1 || href.indexOf('payment-plan') > -1 || a.getAttribute('data-tcb-financing') != null) &&
      typeof ta.financingClick === 'function'
    ) {
      ta.financingClick({ source: linkSource(href) || 'financing_link' });
    }
  }

  function wireContactForm() {
    var form = document.getElementById('tcb-contact-form-el');
    if (!form) return;

    form.addEventListener('submit', function () {
      var ta = analytics();
      if (!ta) return;
      var topicEl = document.getElementById('tcb-contact-topic');
      var topic = topicEl ? topicEl.value : parseTopic(window.location.href);
      ta.formSubmitted('contact', topic);
    });
  }

  function wirePostedSuccess() {
    var panel = document.querySelector('[data-tcb-contact-posted="true"]');
    if (!panel) return;
    var ta = analytics();
    if (!ta) return;
    ta.formSubmitted('contact_success', parseTopic(window.location.href));
  }

  function wireCartAdds() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.tagName !== 'FORM') return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;

        var ta = analytics();
        if (!ta) return;

        var variantInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        ta.addToCart({
          variant_id: variantInput ? variantInput.value : '',
          quantity: qtyInput ? Number(qtyInput.value) || 1 : 1,
          source: form.classList.contains('tcb-cart-form') ? 'pdp' : 'product_form'
        });
      },
      true
    );

    if (!window.fetch) return;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var promise = nativeFetch.apply(this, arguments);

      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        promise.then(function (res) {
          if (!res || !res.ok) return;
          var ta = analytics();
          if (!ta) return;
          res
            .clone()
            .json()
            .then(function (data) {
              ta.addToCart({
                variant_id: data && data.variant_id ? String(data.variant_id) : '',
                quantity: data && data.quantity ? data.quantity : 1,
                source: 'fetch'
              });
            })
            .catch(function () {
              ta.addToCart({ source: 'fetch' });
            });
        });
      }

      return promise;
    };
  }

  function wireAdvisorLanding() {
    if (!document.querySelector('[data-tcb-ai-advisor-landing]')) return;
    var ta = analytics();
    if (ta) ta.advisorOpened({ source: 'page_view' });
  }

  function wireFinderHub() {
    if (!document.querySelector('[data-tcb-equipment-finder-hub]')) return;
    var ta = analytics();
    if (ta) ta.finderOpened({ source: 'page_view' });
  }

  function wireCartPage() {
    var ta = analytics();
    if (!ta) return;
    var isCart =
      document.body &&
      (document.body.classList.contains('template-cart') ||
        /\/cart\/?$/.test(window.location.pathname));
    if (!isCart || typeof ta.viewCart !== 'function') return;

    var itemCount = 0;
    var value = 0;
    try {
      var countEl = document.querySelector('[data-cart-count], [data-tcb-cart-count], .cart-count');
      if (countEl) itemCount = Number(countEl.textContent) || 0;
    } catch (e) { /* ignore */ }

    ta.viewCart({ item_count: itemCount, value: value, source: 'cart_page' });

    document.addEventListener(
      'click',
      function (event) {
        var checkout = event.target && event.target.closest
          ? event.target.closest('button[name="checkout"], [href*="/checkout"], [data-tcb-checkout], a[href="/checkout"]')
          : null;
        if (!checkout || typeof ta.beginCheckout !== 'function') return;
        ta.beginCheckout({ item_count: itemCount, value: value, source: 'cart_checkout' });
      },
      true
    );
  }

  document.addEventListener('click', onDocumentClick, false);
  document.addEventListener('DOMContentLoaded', function () {
    wireContactForm();
    wirePostedSuccess();
    wireCartAdds();
    wireAdvisorLanding();
    wireFinderHub();
    wireCartPage();
  });
})();
